<script setup lang="ts">
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { WifiIcon } from '@heroicons/vue/24/outline'
import { useNetwork } from '@vueuse/core'
import { ref } from 'vue'

const { isOnline } = useNetwork()
const dialogPanel = ref(null)
</script>

<template>
    <TransitionRoot appear as="template" :show="!isOnline">
        <Dialog :initialFocus="dialogPanel" as="div" class="relative z-20">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-300"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black/25" />
            </TransitionChild>
            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild
                        as="template"
                        enter="duration-300 ease-out"
                        enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100"
                        leave="duration-200 ease-in"
                        leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95"
                    >
                        <DialogPanel
                            class="w-full max-w-md transform overflow-hidden rounded-sm bg-white px-6 py-8 text-left align-middle shadow-xl transition-all"
                            ref="dialogPanel"
                        >
                            <div
                                class="flex flex-1 flex-col items-center justify-center text-center space-y-4"
                            >
                                <div class="rounded-full p-3 bg-primary-100">
                                    <WifiIcon class="size-9 text-primary-700" aria-hidden="true" />
                                </div>
                                <DialogTitle
                                    as="h3"
                                    class="text-xl font-semibold leading-4 tracking-wide text-primary-700"
                                >
                                    {{ $t('widget.offline.title') }}
                                </DialogTitle>
                                <p class="text-sm text-neutral-600">
                                    {{ $t('widget.offline.description') }}
                                </p>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
